/*
 * bundle-guard.js  (NEW FILE - proposed, not applied)
 * EKM $0 "Bundle Product" pages (template product.package-cart-unroll, Bold Product Options v2).
 *
 * What it does:
 *  1. Keeps the visible Add to cart button disabled until Bold Product Options has loaded AND
 *     properties[_boldVariantIds] holds at least one option variant that product-packages.js can unroll
 *     (i.e. every selected id exists in window.PRODUCT_MAPPING).
 *  2. Blocks, in the capture phase, any add-to-cart click or native form submit that happens before that
 *     (this is the path that put "$0 package only" lines in the cart).
 *  3. Shows Bold's configured total (.bold_option_price_display) once it is above $0, otherwise shows the
 *     server-rendered label span ([data-bundle-price-label]). Bold parses the total span's original text as
 *     the base price, so that span keeps "$0.00" and is only hidden/shown, never rewritten.
 *
 * What it does NOT touch: product-packages.js (the unroll script), Bold's options.js, Bold's
 * clone/hidden button flow. When a selection exists, clicks pass straight through to Bold and then to
 * product-packages.js exactly as today.
 */
(function () {
  'use strict';

  var cfgEl = document.querySelector('script[data-zero-bundle-config]');
  if (!cfgEl) { return; }
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }

  var form = document.getElementById(cfg.formId);
  if (!form) { return; }

  var MSG_SELECT = cfg.msgSelect || 'Please choose at least one option for this package before adding it to your cart.';
  var MSG_LOADING = cfg.msgLoading || 'Loading package options\u2026';
  var MSG_SLOW = cfg.msgSlow || 'Package options did not load. Please refresh the page, or contact us to order this package.';
  var MSG_UNMAPPED = cfg.msgUnmapped || 'One of the selected options cannot be added online right now. Please contact us to order this package.';
  var LOAD_TIMEOUT_MS = cfg.loadTimeoutMs || 15000;
  var started = Date.now();

  var msgEl = document.createElement('p');
  msgEl.className = 'bundle-guard-message';
  msgEl.setAttribute('role', 'status');
  msgEl.setAttribute('aria-live', 'polite');
  var atc = form.querySelector('.add-to-cart');
  if (atc && atc.parentNode) { atc.parentNode.insertBefore(msgEl, atc.nextSibling); }

  function idsInput() { return form.querySelector('input[name="properties[_boldVariantIds]"]'); }
  // Bold only creates the _boldVariantIds input once something is selected, so it is not part of "loaded".
  function boldLoaded() { return !!form.querySelector('.bold_options_loaded'); }
  function selectedIds() {
    var el = idsInput();
    if (!el || !el.value) { return []; }
    return el.value.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function unmappedIds(ids) {
    var map = window.PRODUCT_MAPPING || {};
    return ids.filter(function (id) { return !map[id]; });
  }
  function state() {
    if (!boldLoaded()) { return (Date.now() - started > LOAD_TIMEOUT_MS) ? 'slow' : 'loading'; }
    var ids = selectedIds();
    if (!ids.length) { return 'empty'; }
    if (!window.PRODUCT_MAPPING || unmappedIds(ids).length) { return 'unmapped'; }
    return 'ok';
  }
  function originalBtn() { return form.querySelector('input.add-to-cart-button:not(.bold_clone)'); }
  function cloneBtn() { return form.querySelector('input.add-to-cart-button.bold_clone'); }

  function setMsg(s) {
    var text = '';
    if (s === 'loading') { text = MSG_LOADING; }
    else if (s === 'slow') { text = MSG_SLOW; }
    else if (s === 'empty') { text = MSG_SELECT; }
    else if (s === 'unmapped') { text = MSG_UNMAPPED; }
    msgEl.textContent = text;
    msgEl.style.display = text ? '' : 'none';
  }

  function fixPriceLabel() {
    var span = document.querySelector('.bold_option_price_display[data-zero-bundle-price]');
    var label = document.querySelector('[data-bundle-price-label]');
    if (!span || !label) { return; }
    var digits = (span.textContent || '').replace(/[^0-9.]/g, '');
    var showTotal = digits !== '' && parseFloat(digits) > 0;
    span.style.display = showTotal ? '' : 'none';
    label.style.display = showTotal ? 'none' : '';
  }

  function update() {
    var s = state();
    var orig = originalBtn();
    var clone = cloneBtn();
    var ok = s === 'ok';
    if (clone) {
      // Bold hides the original and programmatically clicks it after its own validation;
      // a disabled input would swallow that click, so the original must stay enabled once Bold owns the flow.
      if (orig) { orig.disabled = false; orig.removeAttribute('aria-disabled'); }
      clone.disabled = !ok;
      clone.setAttribute('aria-disabled', ok ? 'false' : 'true');
      clone.classList.toggle('disabled', !ok);
    } else if (orig) {
      orig.disabled = !ok;
      orig.setAttribute('aria-disabled', ok ? 'false' : 'true');
      orig.classList.toggle('disabled', !ok);
    }
    setMsg(s);
    fixPriceLabel(s);
    return s;
  }

  function isAddToCart(el) {
    return el && el.matches && el.matches('input[type="submit"].add-to-cart-button') && form.contains(el);
  }

  // Capture phase on document runs before Bold's and jQuery's handlers on the button.
  document.addEventListener('click', function (e) {
    if (!isAddToCart(e.target)) { return; }
    if (update() !== 'ok') {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // The only legitimate add path for these pages is product-packages.js (AJAX /cart/update).
  // A native submit would add the $0 parent only, so it is always stopped here.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (update() === 'ok' && typeof window.addToCart === 'function') {
      window.addToCart.call(form, e);
    }
  }, true);

  form.addEventListener('change', function () { setTimeout(update, 0); }, true);
  form.addEventListener('click', function () { setTimeout(update, 50); }, false);

  // Bold updates hidden inputs by script (no change events), so poll lightly.
  update();
  var timer = setInterval(function () {
    update();
  }, 400);
  // Keep polling while the page is open; it is a cheap DOM read. Stop if the form is removed.
  var stopper = setInterval(function () {
    if (!document.body.contains(form)) { clearInterval(timer); clearInterval(stopper); }
  }, 5000);
})();
